/**
 * Escalation Matrix & Helpdesk Communication Protocol.
 *
 * The matrix itself lives in the `escalation_matrix` table and is served by
 * GET /api/support/escalation-matrix — nothing here hardcodes it. This module
 * only holds the shape of that payload and the presentation ramp applied to it.
 */

export interface SupportContact {
  email: string;
  /** Only set where contacts within a level own different modules. */
  modules?: string;
}

export interface SupportLevel {
  level: string;
  role: string;
  /** Window to acknowledge the issue — not to resolve it. */
  sla: string;
  /** Set when every contact in the level covers the same scope. */
  scope?: string;
  contacts: SupportContact[];
}

/**
 * Colour ramp for the ladder, cool (fast, front line) to hot (slow, senior).
 * Applied by position rather than by level code, so adding or renaming a level
 * in the table needs no change here. Levels past the ramp reuse the last stop.
 */
const LEVEL_RAMP = [
  { tone: '#0e7c86', wash: '#e4f2f3' },
  { tone: '#4b6bb7', wash: '#eaeef9' },
  { tone: '#b4741c', wash: '#f8efdf' },
  { tone: '#c0562a', wash: '#faebe3' },
  { tone: '#a3323c', wash: '#f8e7e9' },
];

export const levelRamp = (index: number) =>
  LEVEL_RAMP[Math.min(index, LEVEL_RAMP.length - 1)];
